/** Whether a title or name matches what's typed: the whole text, or every typed word starting one of its words. */
export function nameMatches(name: string, typed: string): boolean {
  const query = typed.toLowerCase().trim();
  if (query.length < 2) return false;
  const typedWords = query.split(/[^a-z0-9]+/).filter((w) => w.length >= 2);
  const lower = name.toLowerCase();
  const nameWords = lower.split(/[^a-z0-9]+/);
  return (
    lower.includes(query) ||
    (typedWords.length > 0 && typedWords.every((tw) => nameWords.some((w) => w.startsWith(tw))))
  );
}
